/* eslint-disable jsx-a11y/anchor-is-valid */
/*jshint esversion: 9 */

import React, { useState } from "react";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import { RiDownloadLine } from "react-icons/ri";
import CountUp from "react-countup";
import "./TabbedProjectComponent.css";
import "../style.css"
import Carousel from "./ProjectDetails/Carousel";
import Select from "react-select";
import "../../Pages/style.css"
import Loading from "../../../shared/Loading/Loading"

const sortOptions = [
  { value: "", label: "None" },
  { value: "date", label: "Date" },
  { value: "technology", label: "Technology" },
  { value: "priority", label: "Priority" },
];
const customStyles = {
  control: (provided) => ({
    ...provided,
    border: "none",
    backgroundColor: "#e5e5e5",
    boxShadow: "none",
    color: "white",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "orange" : "transparent",
    color: state.isFocused && "black",
   
  }),
};



const TabbedProjectComponent = ({ data }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState({});
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [category, setCategory] = useState("All"); // Selected category
  const [sortType, setSortType] = useState(""); // Selected sort type
  const [searchQuery, setSearchQuery] = useState("");

  const [likedProjects, setLikedProjects] = useState(() => {
    const likedProjectsFromStorage = localStorage.getItem("likedProjects");
    return likedProjectsFromStorage ? JSON.parse(likedProjectsFromStorage) : {};
  });
  const [clickCounts, setClickCounts] = useState(() => {
    const clickCountsFromStorage = localStorage.getItem("clickCounts");
    return clickCountsFromStorage ? JSON.parse(clickCountsFromStorage) : {};
  });

  // Helper function to handle liking or unliking a project
  const handleLikeToggle = (projectId) => {
    setLikedProjects((prevLikedProjects) => {
      const updatedLikedProjects = { ...prevLikedProjects };
      if (updatedLikedProjects[projectId]) {
        // If already liked, remove from liked projects
        delete updatedLikedProjects[projectId];
      } else {
        // If not liked, add to liked projects
        updatedLikedProjects[projectId] = true;
      }
      localStorage.setItem(
        "likedProjects",
        JSON.stringify(updatedLikedProjects)
      );
      return updatedLikedProjects;
    });

    setClickCounts((prevClickCounts) => {
      const updatedClickCounts = { ...prevClickCounts };
      if (updatedClickCounts[projectId]) {
        // If already clicked, decrement the count
        updatedClickCounts[projectId] -= 1;
      } else {
        // If not clicked, increment the count
        updatedClickCounts[projectId] = 1;
      }
      localStorage.setItem("clickCounts", JSON.stringify(updatedClickCounts));
      return updatedClickCounts;
    });
  };




  const itemsPerPage = 6; // Number of items to show per page

  const handleModalToggle = (itemId) => {
    setShowModal((prevShowModal) => ({
      ...prevShowModal,
      [itemId]: !prevShowModal[itemId],
    }));
  };

 
  // Extracting unique categories from the data
  const categories = ["All", ...new Set(data.flatMap((item) => item.category))];

  // Helper function to sort data based on the selected sort type
  const sortData = (data, sortType) => {
    switch (sortType) {
      case "date":
        return data.sort((a, b) => new Date(b.date) - new Date(a.date));
      case "technology":
        return data.sort((a, b) => a.technology.length - b.technology.length);
      case "priority":
        return data.sort((a, b) => b.priority - a.priority);
      default:
        return data;
    }
  };
  

  

  const filterData = (data, searchQuery) => {
    if (!searchQuery) {
      return data;
    }
  
    const lowercasedQuery = searchQuery.toLowerCase();
    return data.filter(
      (item) =>
        item.links.details.titleSmall.toLowerCase().includes(lowercasedQuery) ||
        item.links.details.titleBig.toLowerCase().includes(lowercasedQuery)
    );
  };
  


  // Calculate total number of pages and search
  const filteredData = filterData(
    data.filter((item) => category === "All" || item.category.includes(category)),
    searchQuery
  );
  

  // Sort data based on the selected sort type
  const sortedData = sortData(filteredData, sortType);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);

  // Get the current page's data
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageData = sortedData.slice(startIndex, endIndex);
  console.log(currentPageData);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setIsLoading(true);
  
    // Simulate loading with a setTimeout
    setTimeout(() => {
      setCurrentPage(pageNumber);
      setIsLoading(false); // Set isLoading to false after the timeout
    }, 1000); // You can adjust the timeout duration as needed
  };
  

  // Handle tab selection
  const handleTabSelect = (selectedCategory) => {
    setIsLoading(true); 
    setCategory(selectedCategory);
    setCurrentPage(1); // Reset page number when tab changes
    setSearchQuery(""); // Reset search query when tab changes
    setTimeout(() => {
      setIsLoading(false); // Set loading to false when data is ready
    }, 1000);
  };
  

  // Handle sort selection
  const handleSortSelect = (selectedSortType) => {
    setSortType(selectedSortType);
    setCurrentPage(1); // Reset page number when sort changes
  };

  // Handle load more button click
  const handleLoadMore = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  // Determine if pagination buttons and load more button should be disabled
  const isPreviousDisabled = currentPage === 1;
  const isNextDisabled = currentPage === totalPages;
  const isLoadMoreDisabled = currentPage * itemsPerPage >= sortedData.length;


  return (
    <div className="container mx-auto px-12 mb-20 md:mb-0">
      {/* <h1>{data.length}</h1> */}
      <div className="title-section text-center">
        <h1>
          my{" "}
          <span
            className="text-amber-500"
            data-aos-duration="1500"
            data-aos-easing="ease-in-out"
            data-aos="zoom-in"
          >
            Portfolio
          </span>
        </h1>
        <span
          className="title-bg lg:-ml-6"
          data-aos-duration="3500"
          data-aos-easing="ease-in-out"
          data-aos="fade-right"
        >
          works <CountUp duration={8} end={data.length} />
        </span>
        {/* <span className='title-project-count'>Total Projects <CountUp duration={5} end={data.length} /></span> */}
      </div>
    
      <div className="container md:flex items-center justify-around mb-14">
        <div>
          {/* implement search here base on the [titleSmall,titleBig] where i can search all project this search field  */}
          <div className="parent-searchBar">
          <div class="animation-searchBar">
            <input
              type="text"
              placeholder="Search Project......"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div class="search-icon"></div>
          </div>
        </div>

        </div>
       
        <div className="flex flex-wrap justify-center mt-7 lg:mt-0">
        {categories.map((categoryName, index) => (
          <button
            key={index}
            className={`category-button ${
              category === categoryName ? "category-button-active" : ""
            }`}
            onClick={() => handleTabSelect(categoryName)}
          >
            [ {categoryName} ]
          </button>
        ))}
      </div>


<div className="hidden md:flex filtering-sort items-center">
  <label htmlFor="sortSelect" className="mr-2">
    Sort by:
  </label>
  <Select
    id="sortSelect"
    defaultValue={sortOptions[0]}
    isClearable
    isSearchable
    name="color"
    options={sortOptions}
    getOptionLabel={(option) => option.label}
    onChange={(selectedOption) =>
      handleSortSelect(selectedOption ? selectedOption.value : "")
    }
     styles={customStyles} 
    className=" border border-gray-300 text-gray-900 text-sm rounded-lg    dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white  "
  />
</div>


      </div>

      <div className="mt-8">
        

      {isLoading ? (
      <Loading/>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-14">
        {currentPageData.map((item, index) => (
          <div
            key={index}
            // data-aos="zoom-in-right"
            // data-aos-duration="1500"
            className="portfolio-card text-accent hover:text-white"
          >
            <div className="text-left">
            <div className="image-content w-full rounded-xl overflow-hidden">
          {/* The banner image */}
          <img
              src={item.links.bannerImg}
              alt=""
              className="banner-image"
          />
          {/* The new image */}
          <img
            src={item.links.image}
              alt=""
              className="hover-image"
          />
      </div>
              <div>
                <h2 className="font-semibold text-sm my-4 text-primary">
                  {item.links.details.titleSmall}
                </h2>
                <h2 className="project-title text-accent font-semibold text-xl my-4">
                  {item.links.details.titleBig}
                  <i className="title-icon text-primary ml-2 fa-solid fa-arrow-turn-up"></i>
                  {item.popular === "Popular" && (
        <span className="popular-indicator" data-label="Popular"></span>
      )}
                </h2>
              {/* add priority */}
      {/* <h3 className="font-semibold text-white">Priority: {item.priority}</h3> */}
              </div>
              <div className="button-content h-12 flex justify-between items-center mt-5">
                <a
                  href="#"
                  className="project-button text-[10px] lg:text-[12px]"
                  onClick={() => handleModalToggle(item._id)}
                >
                  <i className="text-sm text-primary mr-2 fa-solid fa-circle-dot"></i>
                  View Details
                </a>


                <div
              className={`heart-to -ml-2 ${
                likedProjects[item._id] ? "is-active" : ""
              }`}
              onClick={() => handleLikeToggle(item._id)}
            />
   
       

                <input
                  type="checkbox"
                  id={`my-modal-${item._id}`}
                  className="modal-toggle"
                  checked={showModal[item._id]}
                  onChange={() => handleModalToggle(item._id)}
                />
                {showModal[item._id] && (
                  <div className="modal bg-red-500">
                    <div className="modal-box card-detail-modal w-11/12 max-w-7xl">
                      <label
                        htmlFor={`my-modal-${item._id}`}
                        className="btn btn-sm btn-circle absolute right-2 top-2"
                      >
                        ✕
                      </label>
                      <div class="md:flex gap-3">
                        <div class="md:w-2/3">
                          <Carousel slides={item.slide} />

                          <div className="button-content flex justify-between mt-5">
                            <a
                              href={item.links.live}
                              target="_blank"
                              rel="noreferrer"
                              className="project-button text-[10px] lg:text-[12px]"
                            >
                              <i class="text-sm text-error mr-2 fa-sharp fa-regular fa-circle-dot fa-fade"></i>
                              View Live
                            </a>
                            <a
                              href={item.links.details.client}
                              target="_blank"
                              rel="noreferrer"
                              className="project-button text-[10px] lg:text-[12px]"
                            >
                              <i className="text-sm text-primary mr-2 fa-brands fa-github"></i>
                              Client Code
                            </a>
                            <a
                              href={item.links.details.server}
                              target="_blank"
                              rel="noreferrer"
                              className="project-button text-[10px] lg:text-[12px]"
                            >
                              {" "}
                              <i className="text-sm text-primary mr-2 fa-brands fa-github"></i>
                              Server Code
                            </a>
                          </div>
                          
                        </div>
                        <div class="md:w-1/3">
                          <div
                            id="task"
                            className="flex justify-between items-center border-b border-slate-200 py-3 px-2 border-l-4 border-[#FFA001] bg-gradient-to-r from-[#ffa2016c] to-transparent hover:from-[#ffa20144] transition ease-linear duration-150"
                          >
                            <div className="inline-flex items-center space-x-2">
                              <div></div>
                              <div>
                                <ol className="description-list">
                                  {item.links.details.desc
                                    .split("\n")
                                    .map((line, index) => (
                                      <li key={index}>{line}</li>
                                    ))}
                                </ol>
                              </div>
                            </div>
                          </div>

                          <div>
                              <h3 className="font-semibold text-lg my-2">Used Technology:</h3>
                              <p className="technology-container">
                                {item.technology.map((tech, index) => (
                                  <span key={index} className="technology-item">
                                    {tech.techLeft} {tech.techRight}
                                  </span>
                                ))}
                              </p>
                            </div>


                            

                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <a
                  href={item.links.live}
                  target="_blank"
                  rel="noreferrer"
                  className="project-button text-[10px] lg:text-[12px]"
                >
                  {/* <i className="text-sm text-primary mr-2 fa-solid fa-circle-dot"></i> */}
                  <i class="text-sm text-error mr-2 fa-sharp fa-regular fa-circle-dot fa-fade"></i>
                  View Live
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

        )}
       
        {/* Pagination or Load More button */}
        {category === "All" ? (
          <div className="flex justify-center py-9">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={isPreviousDisabled}
              className={`button-pagination ${
                isPreviousDisabled ? "button-pagination-disabled" : ""
              } ${currentPage === 1 ? "button-pagination-active" : ""}`}
            >
              <FiChevronsLeft />
            </button>
            {Array.from({ length: totalPages }).map((_, index) => (
              <button
                key={index}
                onClick={() => handlePageChange(index + 1)}
                className={`button-pagination ${
                  currentPage === index + 1 ? "button-pagination-active" : ""
                }`}
              >
                {index + 1}
              </button>
            ))}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={isNextDisabled}
              className={`button-pagination ${
                isNextDisabled ? "button-pagination-disabled" : ""
              } ${
                currentPage === totalPages ? "button-pagination-active" : ""
              }`}
            >
              <FiChevronsRight />
            </button>
          </div>
        ) : (
          <div className="flex justify-center py-9">
            <button
              onClick={handleLoadMore}
              disabled={isLoadMoreDisabled}
              className={`button-pagination ${
                isLoadMoreDisabled ? "button-disabled" : ""
              }`}
            >
              {isLoadMoreDisabled ? (
                <p>No More Projects</p>
              ) : (
                <button className="load-more-button flex items-center">
                  <p>Load More</p>{" "}
                  <RiDownloadLine
                    className="download-icon"
                    style={{ marginLeft: "4px" }}
                  />
                </button>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TabbedProjectComponent;
